<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="col-6">
                <h4 class="card-title">İşletme Listesi</h4>
              </div>
              <div style="text-align: right;" class="col-6 card-title">
                <a style="color:#fff" href="/#/admin/corporation">
                  <button type="submit" class="btn btn-info btn-fill float-right">
                    Yeni İşletme
                  </button>
                </a>
              </div>
            </template>
            <a-table rowKey="id" :columns="columns" :data-source="corporations.corporations">
              <a slot="action" slot-scope="text, record" class="actions-area">
                <a-button type="dashed"> <a-icon type="edit" /> </a-button>
                <a-popconfirm
                  @confirm="confirmDelete(record.id)"
                  title="Silmek istediğinize emin misiniz?" 
                  ok-text="Evet" 
                  cancel-text="Hayır">
                  <a-button type="danger"> <a-icon type="delete" /> </a-button>
                </a-popconfirm>
              </a>
            </a-table>
          </card>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import Card from 'src/components/Cards/Card.vue'
  export default {
     mounted() {
      console.log("mounted corporation list")
      const self = this
      self.$store.dispatch("Corporation/requestCorporationList")
    },
    computed: {
      ...mapState({
        corporations: state => state.Corporation.corporations
      }),
    },
    components: {
      Card
    },
    methods: {
      confirmDelete(corporation_id){
        const self = this
        self.$store.dispatch("Corporation/requestCorporationDelete", corporation_id).then(()=> {
          self.$notification['success']({
            message: 'İşletme Silme',
            description:
              'İşletme başarılı bir şekilde silindi :)',
          });
        }).catch(()=> {
          self.$notification['error']({
            message: 'İşletme Silme',
            description:
              'İşletme silinirken bir hata oluştu :/',
          });
        })
      }
    },
    data () {
      return {
        columns: [
          { title: 'ID', dataIndex: 'id', key: 'id'},
          { title: 'İşletme Adı', dataIndex: 'corporation_name', key: 'corporation_name'},
          { title: 'Sorumlu Kişi Adı', dataIndex: 'owner_name', key: 'owner_name'},
          { title: 'Telefon', dataIndex: 'phone_number', key: 'phone_number'},
          { title: 'Adres', dataIndex: 'address', key: 'address'},
          {
            title: 'İşlemler',
            key: 'operation',
            width: '20%',
            scopedSlots: { customRender: 'action' },
          },
        ]
      }
    }
  }
</script>
<style>
</style>
